module.exports = __webpack_public_path__ + "img/news8-5.9ca5ea2b.png";